export default "__VITE_ASSET__DfaP0jWY__"